// Consistent user profiles for the forum
export const USER_PROFILES = {
  currentUser: {
    name: 'Alex Chen',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    isExpert: false
  },
  sarahJohnson: {
    name: 'Sarah Johnson',
    avatar: 'https://randomuser.me/api/portraits/women/42.jpg',
    isExpert: false
  },
  michaelClark: {
    name: 'Michael Clark',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    isExpert: false
  },
  neginNickparsa: {
    name: 'Negin Nickparsa',
    avatar: '/images/profiles/negin-nickparsa.jpg',
    isExpert: false
  },
  aliReza: {
    name: 'Ali Reza',
    avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
    isExpert: false
  },
  maryamGhorbali: {
    name: 'Maryam Ghorbali',
    avatar: '/images/profiles/maryam-ghorbali.jpg',
    isExpert: false
  },
  davidChen: {
    name: 'David Chen',
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
    isExpert: false
  },
  ninaPatel: {
    name: 'Nina Patel',
    avatar: 'https://randomuser.me/api/portraits/women/89.jpg',
    isExpert: false
  },
  amirHosseini: {
    name: 'Salman Zahabioun',
    avatar: '/images/profiles/Salman Zahabioun.jpg',
    isExpert: false
  },
  // Expert profiles
  drAmirTehrani: {
    name: 'Dr. Amir Tehrani',
    avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
    isExpert: true
  },
  drFatimaAlZahra: {
    name: 'Dr. Fatima Al-Zahra',
    avatar: 'https://randomuser.me/api/portraits/women/67.jpg',
    isExpert: true
  },
  chefParisaMoghaddam: {
    name: 'Chef Parisa Moghaddam',
    avatar: 'https://randomuser.me/api/portraits/women/90.jpg',
    isExpert: true
  },
  drLeilaShirazi: {
    name: 'Dr. Leila Shirazi',
    avatar: 'https://randomuser.me/api/portraits/women/34.jpg',
    isExpert: true
  },
  profHassanMirza: {
    name: 'Prof. Hassan Mirza',
    avatar: 'https://randomuser.me/api/portraits/men/91.jpg',
    isExpert: true
  },
  drMinaTehrani: {
    name: 'Dr. Mina Tehrani',
    avatar: 'https://randomuser.me/api/portraits/women/45.jpg',
    isExpert: true
  },
  // Additional community members
  mohammadKarimi: {
    name: 'Mohammad Karimi',
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
    isExpert: false
  },

  karimZadeh: {
    name: 'Karim Zadeh',
    avatar: 'https://randomuser.me/api/portraits/men/78.jpg',
    isExpert: false
  },
  sofiaRodriguez: {
    name: 'Sofia Rodriguez',
    avatar: 'https://randomuser.me/api/portraits/women/56.jpg',
    isExpert: false
  },
  // Additional users from Forum.tsx
  mariaSantos: {
    name: 'Maria Santos',
    avatar: 'https://randomuser.me/api/portraits/women/34.jpg',
    isExpert: false
  },
  hassanMirza: {
    name: 'Hassan Mirza',
    avatar: 'https://randomuser.me/api/portraits/men/91.jpg',
    isExpert: false
  },
  emmaThompson: {
    name: 'Emma Thompson',
    avatar: 'https://randomuser.me/api/portraits/women/45.jpg',
    isExpert: false
  },
  javadNouri: {
    name: 'Javad Nouri',
    avatar: 'https://randomuser.me/api/portraits/men/89.jpg',
    isExpert: false
  }
}; 